import React, { FC } from 'react';
import { styled } from 'styled-components';
import { LOAD_LANE_STATUS_CONFIG } from '@/modules/loadlanes/constants';
import { defaultTheme } from '@/ui/theme';
import {
  getLoadStatusTone,
  LoadStatusTone,
} from '@/modules/TransportMovement/loadList';
import { NotRecorded } from '@/modules/TransportMovement/components/NotRecorded';

const LOAD_STATUS_TONES: Record<LoadStatusTone, { color: string; bg: string }> =
  {
    planned: { color: defaultTheme.main, bg: defaultTheme.primaryBg10 },
    awaitingDispatch: {
      color: LOAD_LANE_STATUS_CONFIG.dueSoon.color,
      bg: LOAD_LANE_STATUS_CONFIG.dueSoon.tabBg,
    },
    dispatched: {
      color: LOAD_LANE_STATUS_CONFIG.onTime.color,
      bg: LOAD_LANE_STATUS_CONFIG.onTime.bg,
    },
    other: {
      color: LOAD_LANE_STATUS_CONFIG.vacant.color,
      bg: LOAD_LANE_STATUS_CONFIG.vacant.bg,
    },
  };

const Pill = styled.span<{ $color: string; $bg: string }>`
  display: inline-block;
  max-width: 100%;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
`;

export const LoadStatusPill: FC<{ status?: string | null }> = ({ status }) => {
  if (!status) return <NotRecorded />;
  const { color, bg } = LOAD_STATUS_TONES[getLoadStatusTone(status)];
  return (
    <Pill $color={color} $bg={bg} title={status}>
      {status}
    </Pill>
  );
};
